exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right_menu[data-v-015a91f6] {\n    -webkit-box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.3);\n    position: fixed;\n    padding: 4px 2px;\n}\n.right_menu_light[data-v-015a91f6] {\n    background: #f3f3f3;\n}\n.right_menu_dark[data-v-015a91f6] {\n    border: 1px solid #bbbbbb;\n    background: #282828;\n}\n.right_menu_outline[data-v-015a91f6] {\n    width: 90%;\n    height: 1px;\n    margin: 3px 0 3px 5%;\n}\n.right_menu_outline_light[data-v-015a91f6] {\n    background: #aaaaaa;\n}\n.right_menu_outline_dark[data-v-015a91f6] {\n    background: #bbbbbb;\n}\n", ""]);

// exports
